import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddCreativeTextFB } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddCreativeTextPage: FC = () => {
  const { accessToAddOriginaltextcreative } = usePermissionGuard();
  return (
    <Guard hasAccess={accessToAddOriginaltextcreative}>
      <CabinetTitlePage
        title={'Creative texts'}
        goBack={'/cabinet/facebook/creative-texts'}
      />
      <AddCreativeTextFB />
    </Guard>
  );
};

export default AddCreativeTextPage;
